import constate from 'constate'
import { TUser } from '../definitions'

const useUser = ({ user }: { user: TUser }) => user

export const [UserProvider, useUserContext] = constate(useUser)
